import { memo, useState } from 'react';
import { useResponsive } from '../../../../../../hooks';
import { Container, ListWrapper } from './auto-meters.styled';
import { Button, HStack, SVG, Text, VStack } from '../../../../components-v4';
import { IPublicRequestMetersData } from 'app/pages/request-single-page/request-single-page-slice';
import { MeterCard } from '../meter-card';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';

type AutoMetersProps = {
  meters: IPublicRequestMetersData[];
};

export const AutoMeters = memo(({ meters }: AutoMetersProps) => {
  const { viewport } = useResponsive();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <Container>
      <VStack spacing="xxs">
        <HStack align="center" justify="space-between">
          <Text variant="heading-4">Автоматизированные счётчики</Text>
          <Button
            iconButton={
              <SVG src={Icons.Chevron} props={{ isMirror: collapsed }} />
            }
            mode="neutral"
            variant="ghost"
            size="s"
            onClick={() => setCollapsed((prev) => !prev)}
          />
        </HStack>

        <Text
          variant={viewport.mobile ? 'body-14' : 'body-16'}
          color="gray.500"
        >
          Показания этих счётчиков передаются автоматически — вводить данные
          вручную не требуется.
        </Text>
      </VStack>

      {collapsed && (
        <ListWrapper>
          {meters.map((meter) => (
            <MeterCard key={meter.id} {...meter} />
          ))}
        </ListWrapper>
      )}
    </Container>
  );
});
